import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ServicesEdit } from './../_common/servicesEdit';
import messageRef from './../../../assets/images/svg/076-envelope.svg';
import { UploadArea } from './../../_common/upload-area';
import { useDispatch, useSelector } from 'react-redux';
import { Message } from '../_common/message';
import * as R from 'ramda';
import { getUserMessage } from '../../../actions/user-api';
import { CircularProgressbar } from 'react-circular-progressbar';
import { GradientSVG } from './gradientSvg';
import $ from 'jquery';
import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, isSocialNetwork } from '../../../constants/utils/connectionTypes';
import { ServiceCard } from './serviceCard';
import { getProgress } from '../../anticipa/_common/serviceNavbar/calculateProgress';

export const Onboard = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const servicesData = useSelector(state => state.services);
    const [selectedService, setSelectedService] = useState(undefined);
    const [commonServices, setCommonServices] = useState([]);
    const [personnalServices, setPersonnalServices] = useState([]);
    const [otherServices, setOtherServices] = useState([]);
    const [userDocuments, setUserDocuments] = useState({
        items: [doc('démarches', 'communes', 0, 0),
        doc('démarches', 'personnalisées', 0, 0)]
    }
    );
    // const otherEntry = Object.entries(OtherService).map(entry => entry[1])[0];
    // const otherService = service(otherEntry.connectionType, otherEntry.title, otherEntry.icon, 0);

    function service(connectionType, title, icon, progress, tooltip) { return { connectionType: connectionType, title: title, icon: icon, progress: (progress === undefined ? 0 : progress), tooltip: tooltip }; };
    function doc(firstTitle, secondTitle, num, actions) { return { firstTitle: firstTitle, secondTitle: secondTitle, num: num, actions: actions }; };

    const getDocument = (docType) => {
        if (!R.isNil(user) && !R.isNil(user.documents) && user.documents.length > 0) {
            let docIndex = user.documents.findIndex(d => d.fileName === docType);
            if (docIndex !== -1) {
                return user.documents[docIndex];
            }
        }
        return undefined;
    };


    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user.services)) {
            let userCommunServices = commonServices.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1).map((s) => {
                let progress = getProgress(servicesData.serviceData, s.connectionType);
                // if (s.connectionType === ConnectionTypes.bank && progress !== 100){
                //     if (progress === 0){
                //         return 5;
                //     }
                //     return 5 - ((progress*5)/100);
                // }
                return progress === 100 ? 0 : 1;
            });

            let userPersonnalServices = [].concat(personnalServices, otherServices).filter(u => user.services.findIndex(i => isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType :
                isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType) !== -1).map((s) => {
                    let progress = getProgress(servicesData.serviceData, s.connectionType);
                    return progress === 100 ? 0 : 1;
                });

            let demarchesCommuneDocuments = userDocuments.items.find(d => d.secondTitle === "communes");
            demarchesCommuneDocuments.num = userCommunServices.length;
            demarchesCommuneDocuments.actions = userCommunServices.reduce((a, b) => a + b, 0);

            let demarchesPersonnaliseeDocuments = userDocuments.items.find(d => d.secondTitle === "personnalisées");
            demarchesPersonnaliseeDocuments.num = userPersonnalServices.length;
            demarchesPersonnaliseeDocuments.actions = userPersonnalServices.reduce((a, b) => a + b, 0);

            setUserDocuments({ ...userDocuments, items: userDocuments.items });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicesData, user]);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
        let tmp = [];
        [PersonalServices, AuxiliarOptions].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon, 0));
            });
        });
        setPersonnalServices(tmp);

        tmp = [];
        [CommonServices].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon, 0));
            });
        });
        setCommonServices(tmp);

        tmp = [];
        [OtherService].forEach(services => {
            Object.values(services).forEach(obj => {
                tmp.push(service(obj.connectionType, obj.title, obj.icon, 0));
            });
        });
        setOtherServices(tmp);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function isInsurance(str) {
        if (str === ConnectionTypes.voitureAssurance || str === ConnectionTypes.bateau || str === ConnectionTypes.moto || str === ConnectionTypes.scooter) {
            return true;
        }
        return false;
    }

    if (!R.isNil(user.user) && !R.isNil(user.user.setupCompletedDate)) {
        window.location = `/anticipa/dashboard`;
    }


    return (
        <article className="view-calc mb-auto">
            <h1 className="sr-only visually-hidden">Onboard</h1>
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-4">
                    <h2 className="sr-only visually-hidden">Status</h2>
                    <div className="grid-sm grid-sm-narrow grid-lg-auto grid-hd-4">
                        {userDocuments.items.map((d, index) => {
                            return (
                                <div key={index} className="card rounded shadow">
                                    <GradientSVG
                                        startColor="#00b33c"
                                        endColor="#66ccff"
                                        idCSS="idCSS"
                                        rotation={90}
                                    />
                                    <div className="card-body media">
                                        <div className="media-progress mr-3">
                                            <CircularProgressbar value={(d.num - d.actions) / (d.num)} minValue={0} maxValue={1} background={true} text={d.num === 0 ? '0' : d.num.toString()} />
                                        </div>
                                        <div className="media-body my-auto text-truncate">
                                            <h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">{d.firstTitle}<br className="d-none d-md-block" /> {d.secondTitle}</h3>
                                            <p className="h3 text-dark font-weight-bolder lh-solid mb-0">{d.actions.toString()} actions à faire</p>
                                        </div>
                                    </div>
                                    {/* <div className="card-body media">

                                        <div className="rounded-max bg-common d-inherit mr-3 rounded-progress text-center">
                                            <p className="h2 o-40 font-weight-bolder m-auto">{d.num}</p>
                                        </div>
                                        <div className="media-body my-auto text-truncate">
                                            <h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">{d.firstTitle}<br className="d-none d-md-block" /> {d.secondTitle}</h3>
                                            <p className="h3 text-dark font-weight-bolder lh-solid mb-0">{d.actions} actions</p>
                                        </div>
                                    </div> */}
                                </div>
                            );
                        })}
                    </div>
                </header>
            </div>
            <div className="auto-view py-3 pb-lg-0">
                <div className="container-fluid">
                    <section className="block mt-4">
                        <div className="grid-sm grid-1 grid-md-2 align-items-center mt-2">
                            <h2 className="h6 lh-copy text-uppercase font-weight-bolder my-auto">veuillez compléter les données pour chaque section :</h2>
                            <div className="ml-md-auto">
                                <Link to="/anticipa/personal" className="btn p-1 align-middle text-info">Sélectionner d'autres démarches <i className="eva eva-arrow-right-outline align-middle fs-lead"></i></Link>
                            </div>
                        </div>
                        <form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
                            {
                                R.sortWith([R.ascend(R.prop('title'))])(commonServices.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1)).map((s, index) => {
                                    let progress = getProgress(servicesData.serviceData, s.connectionType);
                                    return <ServiceCard key={index} service={s} progress={progress} setSelectedService={setSelectedService} />;
                                })
                            }
                            {
                                R.sortWith([R.ascend(R.prop('title'))])(personnalServices.filter(u => user.services.findIndex(i => isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType :
                                    isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType) !== -1)).map((s, index) => {
                                        let progress = getProgress(servicesData.serviceData, s.connectionType);
                                        return <ServiceCard key={index} service={s} progress={progress} setSelectedService={setSelectedService} />;
                                    })
                            }
                            {
                                otherServices.filter(u => user.services.findIndex(i => i.connectionType === u.connectionType) !== -1).map((s, index) => {
                                    let progress = getProgress(servicesData.serviceData, s.connectionType);
                                    return <ServiceCard key={index} service={s} progress={progress} setSelectedService={setSelectedService} />;
                                })
                            }
                        </form>
                    </section>
                    {/* <section className="block">
                        <div className="grid-sm grid-1 grid-md-3 align-items-center mt-2">
                            <h2 className="grid-column-md-2 h6 lh-copy text-uppercase font-weight-bolder my-auto">Vous pouvez dès à présent déposer vos documents et laisser un message à votre mandataire.</h2>
                            <div className="ml-md-auto">
                                <Link to="/anticipa/biblioteque" className="btn p-1 lh-1 align-middle text-info">Voir documents <i className="eva eva-arrow-right-outline align-middle fs-lead"></i></Link>
                            </div>
                        </div>
                        <form className="grid-sm grid-sm-narrow grid-lg-4 py-sm">
                            <UploadArea documentName="Document d'identité" uploadedFile={getDocument("Document d'identité")} />
                            <UploadArea documentName="Livret de Famille" uploadedFile={getDocument("Livret de Famille")} />
                            <UploadArea documentName="Donation entre époux" uploadedFile={getDocument("Donation entre époux")} tooltip={"(toutes les pages écrites jusqu'à une page vierge)"} />
                            <div className="card rounded upload-card uploaded">
                                <div className="card-body text-center py-4 my-auto o-80" role="button" data-toggle="modal" data-target="#messageEdit" onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(getUserMessage());
                                }}>
                                    <img className="img-fluid h-5 mx-auto mt-auto" src={messageRef} alt="message Ref" />
                                    <div className="container-tight mx-auto mb-auto pt-1">
                                        <h3 className="small mb-0 lh-copy">Écrivez un message <br /> à votre Mandataire</h3>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <Message />
                    </section> */}
                </div>
            </div>
            <ServicesEdit selectedService={selectedService} setSelectedService={setSelectedService} />
        </article>
    );
};